<template>
  <div id="cart">
    <menu-default/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center"><i class="fa fa-shopping-cart"></i> Carrinho de Compras</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
        <div v-show="cart.length === 0" class="w-100">
              <div class="alert alert-light" role="alert">
              <h4 class="alert-heading">Seu carrinho está vazio</h4>
              <p>Adicione publicações em seu carrinho para finalizar sua compra</p>
              <hr>
              <p class="mb-0"><button class="btn btn-outline-primary" @click="redirectURL({name: 'publications'})">Adicione publicações em seu carrinho</button></p>
            </div>
        </div>
        <div v-show="cart.length > 0" class="w-100">
          <div  class="table-responsive">
            <table class="table table-bordered table-bordered">
              <thead class="thead-dark">
              <tr>
                <th scope="col">Product</th>
                <th scope="col" class="text-center" width="160">Quantity</th>
                <th scope="col" class="text-right" width="200">Price</th>
                <th width="20"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,i) in cart" :key="item">
                <td>{{ item.name }}</td>
                <td class="text-center">
                  <button :disabled="item.quantity === 1"  @click="removeQuantity(item)" v-show="!item.is_download" style="margin-right: 8px"> - </button>
                  {{ item.quantity }}
                  <button  @click="addQuantity(item)" v-show="!item.is_download" style="margin-left: 8px"> + </button></td>
                <td class="text-right">R$ {{ item.price }}</td>
                <td class="text-right"><button class="btn btn-sm btn-danger" @click="removeFromCart(i)"><i class="fa fa-trash"></i> </button> </td>
              </tr>
              <tr>
                <td colspan="3" class="text-right"><strong>Total: R$ {{ priceSum | formatPrice }}</strong></td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>

        <div class="col mb-2">
          <div class="row">
            <div class="col-sm-12  col-md-6">
              <button class="btn btn-lg btn-block btn-outline-secondary" @click="redirectURL({name: 'publications'})"><i class="fa fa fa-undo" aria-hidden="true"></i> Escolher mais publicações</button>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <button class="btn btn-lg btn-block btn-success text-uppercase" @click="redirectURL({name: 'checkout'})">Finalizar Pedido</button>
            </div>
          </div>
        </div>
      </div></div>
      </div>
    </div>

    <footer-default/>
  </div>
</template>

<script>
  import menuDefault from "./common/menu-default"
  import footerDefault from "./common/footer-default"
  import { mapState } from 'vuex'
  import mixins from "../helpers/mixins"
  export default {
    name: "Cart",
    mixins: [mixins],
    components: { menuDefault, footerDefault },
    methods: {
      removeFromCart(i){
        this.$store.commit('deleteFromCart', i)
      },
      addQuantity(item){
        this.$store.dispatch('addProductToCart', item)
      },
      removeQuantity(item){
        this.$store.dispatch('subtractProductToCart', item)
      }
    },
    computed: {
      priceSum() {
        let priceSum = 0.00
        this.cart.forEach(function(product) {
          priceSum = Number(priceSum) + (Number(product.price) * Number(product.quantity))
        });
        return priceSum
      },
      ...mapState(['logged', 'cart'])
    }
  }
</script>

<style scoped>

</style>
